/**
 * Oracle EZConnect parser → oracle.
 *
 *   user/pass@host:1521/SERVICE
 *   host:1521/SERVICE
 *   host/SERVICE          (default port)
 */

import type { ConnectionFormValues } from '../../components/connectionFormSchema';
import type { ConnectionStringParser } from './types';

// user/pass@ (optional) · host · :port (optional) · /service
const EZCONNECT_RE =
  /^(?:([^/@\s:]+)\/([^@\s]*)@)?([^:/@\s]+)(?::(\d+))?\/([^/@\s]+)$/;

export const parseEzConnect: ConnectionStringParser = (input) => {
  const trimmed = input.trim();
  // Rule out other formats: schemes, JDBC, key=value (ADO/libpq), absolute
  // paths, whitespace.
  if (
    /:\/\//.test(trimmed) ||
    /^jdbc:/i.test(trimmed) ||
    trimmed.includes('=') ||
    trimmed.includes(';') ||
    trimmed.includes('\\') ||
    /\s/.test(trimmed) ||
    trimmed.startsWith('/')
  ) {
    return null;
  }

  const m = EZCONNECT_RE.exec(trimmed);
  if (!m) return null;

  const [, user, pass, host, port, service] = m;

  const values: Partial<ConnectionFormValues> = {
    engine: 'oracle',
    server: host,
    oracleServiceName: service,
    oracleUseSID: false,
    oracleConnectionStringType: 'ezconnect',
  };
  const matchedFields: string[] = ['server'];
  if (port) {
    values.port = port;
    matchedFields.push('port');
  }
  matchedFields.push('service name');
  if (user) {
    values.login = user;
    matchedFields.push('user');
  }
  if (pass) {
    values.password = pass;
    matchedFields.push('password');
  }

  return {
    format: 'ezconnect',
    engine: 'oracle',
    values,
    matchedFields,
    unmatchedKeys: [],
  };
};
